<template>
  <el-form ref="form" label-width="130px" :model="pointInfo">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="排查项目名称" prop="screeningItems">
          <el-input
            v-model="pointInfo.screeningItems"
            placeholder="请输入排查项目名称"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="组织级别" prop="organizationLevel">
          <el-input
            v-if="pointInfo.organizationalLevel"
            v-model="pointInfo.organizationalLevel"
            placeholder="请输入组织级别"
            clearable
            :disabled="disabled"
          ></el-input>
          <el-select
            v-if="pointInfo.organizationLevel"
            v-model="pointInfo.organizationLevel"
            placeholder="请输入组织级别"
            clearable
            class="w-full"
            :disabled="disabled"
          >
            <el-option
              v-for="item in controlHierarchyList"
              :key="item.value"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="排查周期" prop="inspectionCycle">
          <el-input
            v-model="unitCycleListMap"
            placeholder="请输入排查周期"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="排查类型" prop="screeningType">
          <el-select
            v-model="typeMap"
            size="small"
            class="w-full"
            placeholder="请选择排查类型"
            :disabled="disabled"
            clearable
          >
            <el-option
              v-for="item in checkTypeList"
              :key="item.value"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="排查标准" prop="screeningCriteria">
          <el-input
            type="textarea"
            v-model="pointInfo.screeningCriteria"
            placeholder="请输入排查标准"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="排查内容" prop="troubleshootingContent">
          <el-input
            type="textarea"
            v-model="pointInfo.troubleshootingContent"
            placeholder="请输入排查内容"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import utils from '@/components/safety/enumField/utils'

export default {
  name: 'plantask-base-form',
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      unitCycleList: [],
      checkTypeList: [],
      pointInfo: {
        screeningItems: null,
        organizationLevel: null,
        inspectionCycle: null,
        screeningType: null,
        unitCycle: null,
        screeningCriteria: null,
        troubleshootingContent: null,
        troubleshootingType: null,
      },
      controlHierarchyList: [],
      areaList: [],
      jobActivityFrequencyList: [],
      jobActivityTypeList: [],
      deviceList: [],
      disabled: true,
    }
  },
  computed: {
    // 排查周期
    unitCycleListMap() {
      const name =
        this.unitCycleList.find((i) => {
          // eslint-disable-next-line eqeqeq
          return i.code == this.pointInfo.unitCycle
        })?.displayName || ''
      return !_.isNil(this.pointInfo.inspectionCycle)
        ? `${this.pointInfo.inspectionCycle}${name}`
        : null
    },
    typeMap() {
      return !_.isNil(this.pointInfo.screeningType)
        ? this.pointInfo.screeningType
        : this.pointInfo.troubleshootingType
    },
  },
  methods: {
    async getPointInfo() {
      const {
        screeningItems,
        organizationLevel,
        inspectionCycle,
        screeningType,
        screeningCriteria,
        troubleshootingContent,
        unitCycle,
        troubleshootingType,
        organizationalLevel,
      } = this.currentRow
      this.pointInfo = {
        screeningItems,
        organizationLevel,
        inspectionCycle,
        screeningType,
        screeningCriteria,
        troubleshootingContent,
        unitCycle,
        troubleshootingType,
        organizationalLevel,
      }
    },
  },
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
      ],
      ['unitCycleList', 'checkTypeList', 'controlHierarchyList'],
      this
    )
    // 获取风险点基本信息
    this.getPointInfo()
  },
}
</script>

<style lang="scss" scoped></style>
